import { useState } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import Footer from "@/pages/home/components/Footer";
import JobListings from "./components/JobListings";
import { URGENCY_JOBS_COUNT, ACTIVE_WORKERS, AVG_MATCH_TIME } from "@/mocks/jobs";

const STATS = [
  { icon: "ri-briefcase-4-line", value: `${URGENCY_JOBS_COUNT}+`, label: "Open Jobs Today" },
  { icon: "ri-user-line", value: `${(ACTIVE_WORKERS / 1000).toFixed(0)}k+`, label: "Active Workers" },
  { icon: "ri-timer-line", value: AVG_MATCH_TIME, label: "Avg. Match Time" },
  { icon: "ri-map-pin-line", value: "230+", label: "Cities Covered" },
];

export default function FindWorkPage() {
  const [searchQuery, setSearchQuery] = useState("");
  const [location, setLocation] = useState("");

  return (
    <div className="min-h-screen bg-[#fafafa]">
      <SiteHeader />

      {/* Hero */}
      <section className="pt-24 pb-10 md:pt-28 md:pb-14 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-emerald-600 bg-emerald-50 px-3.5 py-1.5 rounded-full mb-4">
              Live Job Marketplace
            </span>
            <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-4 leading-tight">
              Find Work Near You.<br />
              <span className="text-emerald-500">Start Earning Today.</span>
            </h1>
            <p className="text-gray-500 text-base md:text-lg mb-7 max-w-xl">
              Browse hundreds of flexible gig jobs matched to your skills and location. Apply in seconds with AI-generated materials.
            </p>

            {/* Search Bar */}
            <div className="flex flex-col sm:flex-row gap-3 max-w-2xl">
              <div className="flex-1 flex items-center bg-white border border-gray-200 rounded-xl px-4 gap-2">
                <i className="ri-search-line text-gray-400 text-sm shrink-0" />
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Job title, skill, or keyword"
                  className="flex-1 py-3 text-sm text-gray-900 outline-none placeholder-gray-400 min-w-0"
                />
              </div>
              <div className="flex items-center bg-white border border-gray-200 rounded-xl px-4 gap-2 sm:w-48">
                <i className="ri-map-pin-line text-gray-400 text-sm shrink-0" />
                <input
                  type="text"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  placeholder="City or zip code"
                  className="flex-1 py-3 text-sm text-gray-900 outline-none placeholder-gray-400 min-w-0 w-full"
                />
              </div>
              <button className="px-6 py-3 bg-emerald-500 text-white font-bold text-sm rounded-xl hover:bg-emerald-600 transition-colors cursor-pointer whitespace-nowrap">
                Search Jobs
              </button>
            </div>
          </div>

          {/* Stats Row */}
          <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-4 sm:gap-6 mt-8 md:mt-10 pt-6 md:pt-8 border-t border-gray-100">
            {STATS.map((s) => (
              <div key={s.label} className="flex items-center gap-2.5">
                <div className="w-8 h-8 flex items-center justify-center bg-emerald-50 rounded-lg shrink-0">
                  <i className={`${s.icon} text-emerald-600 text-sm`} />
                </div>
                <div>
                  <div className="text-base font-extrabold text-gray-900">{s.value}</div>
                  <div className="text-xs text-gray-500">{s.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Job Listings */}
      <section className="py-8 md:py-12">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <JobListings />
        </div>
      </section>

      {/* CTA Band */}
      <section className="py-12 md:py-16 bg-emerald-500">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h2 className="text-xl md:text-3xl font-extrabold text-white mb-3">
            Set Your Availability. Get Matched Instantly.
          </h2>
          <p className="text-emerald-100 text-sm md:text-base mb-7 max-w-lg mx-auto">
            Turn on your availability toggle and let AI bring the right jobs to you — no searching required.
          </p>
          <button className="px-8 py-3.5 bg-white text-emerald-700 font-bold rounded-xl text-sm hover:bg-emerald-50 transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-flashlight-line mr-2" />
            Enable Smart Matching
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
